
import { FormScript, GlobalResponse } from '~/models/Commons ';
import { api } from '../api';
import {CONTRACT_PATH_LIST, CONTRACT_PATH} from '../endpoints';
import { SET_CONTRACTS } from '~/store/feature/Contracts';

const extendedApiSlice = api.injectEndpoints({
        endpoints: (builder) => ({
        getContracts: builder.query<GlobalResponse<any[]>, { page: number; size: number}>({
            query: ({ page, size}) => ({
                url: `${CONTRACT_PATH_LIST}?page=${page}&size=${size}`,
                method: 'GET',
                credentials: 'include',
                headers: {
                    Authorization: sessionStorage.getItem('access_token') ? `Bearer ${sessionStorage.getItem('access_token')}` : ``,
                }
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    dispatch(SET_CONTRACTS(data.payload));
                } catch (error) {
                    console.error("Error fetching contracts:", error);
                }
            },
        }),
      
        deleteContracts: builder.mutation<GlobalResponse<FormScript>, string>({
            query: requesterUniqueId => ({
                url: `${CONTRACT_PATH}/${requesterUniqueId}`,
                method: 'DELETE',
                credentials: 'include',
                headers: {
                    'Authorization': sessionStorage.getItem('access_token') ? `Bearer ${sessionStorage.getItem('access_token')}` : '',
                },
            }),
        }),
    }),
});

export const {
    useGetContractsQuery,
    useLazyGetContractsQuery,
    useDeleteContractsMutation,
} = extendedApiSlice;
